import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { todayLocalDate } from "@/components/vagas/approval-date";
import { invalidDateError } from "@/utils/dateUtils";

interface ApprovalDateFieldProps {
  /** Dia da aprovação ("YYYY-MM-DD"). */
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

/** Campo "Data de aprovação" dos dialogs de aprovar vaga: hoje por padrão, nunca no futuro. */
export function ApprovalDateField({ value, onChange, disabled }: ApprovalDateFieldProps) {
  const today = todayLocalDate();
  const error = invalidDateError(value) ?? (value > today ? "A data não pode ser no futuro." : null);
  return (
    <div className="space-y-2">
      <Label htmlFor="data_aprovacao">
        Data de aprovação <span className="text-red-500">*</span>
      </Label>
      <Input
        id="data_aprovacao"
        type="date"
        max={today}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        className="w-full sm:w-[200px]"
      />
      <p className={error ? "text-xs text-red-600" : "text-xs text-muted-foreground"}>
        {error ?? "Se a aprovação aconteceu antes, use o dia em que ela aconteceu: a vaga conta no mês certo."}
      </p>
    </div>
  );
}
